import { Inject, Injectable } from '@angular/core';
import { WINDOW } from 'src/app/feature/injection-token/window';

@Injectable({ providedIn: 'root' })
export class Base64UtilsService {
	/**
	 * Used to detect a base64 encoded ASCII string
	 * ^                      # Start of input
	 * ([0-9a-zA-Z+/]{4})*    # Groups of 4 valid characters decode # to 24 bits of data for each group
	 * (                      # Either ending with:
	 * ([0-9a-zA-Z+/]{2}==)   # two valid characters followed by ==
	 * |                      # , or
	 * ([0-9a-zA-Z+/]{3}=)    # three valid characters followed by =
	 * )?                     # , or nothing
	 * $                      # End of input
	 */
	private _base64regex: RegExp = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;

	/**
	 * Creates the Base64UtilsService
	 *
	 * @param _window Reference to the client's _window object
	 */
	constructor(@Inject(WINDOW) private _window: Window) {}

	/**
	 * Decodes the provided value
	 * If the value to decode is not a valid base64 string the value will be returned as-is
	 *
	 * @param value The base64 encoded ASCII string to decode
	 * @returns The decoded value
	 */
	public decode(value: string): string {
		if (this._base64regex.test(value)) {
			value = this._window.atob(value);
		}

		return value;
	}

	/**
	 * Encodes the provided value to a base64 string
	 *
	 * @param value  The string of data to base64 encode
	 * @returns The base64 encoded ASCII string
	 */
	public encode(value: string): string {
		return this._window.btoa(value);
	}
}
